import React from 'react';
import { ClipStage } from '../ClipStage';
import { useBeats } from '../../hooks/useBeats';
import { forceClip } from '../../data/teaser';
const BEATS = [900, 1900];
export function ScreenPayoff() {
  const beat = useBeats(BEATS);
  return <section className="flex h-full w-full flex-col justify-center" data-id="element-146" data-mp="1gxq4uif0ztc7">
      <div className="animate-fade-in" data-id="element-147" data-mp="1lv8d06l7y4j5">
        <ClipStage clip={forceClip} heightClass="h-48" frameMs={2400} data-id="element-148" data-mp="1lu70dxok19zb" />
      </div>

      <h1 className="mt-8 text-[31px] font-extrabold leading-[1.1] text-white opacity-0-init animate-fade-in-up" style={{
      animationDelay: '160ms'
    }} data-id="element-149" data-mp="p7lm0o6wzed3">
        Less manual variability.
      </h1>

      <p className={`mt-3 font-headline text-[21px] font-bold leading-[1.2] text-solventum-primary transition-[opacity,transform] duration-300 ease-out ${beat >= 1 ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-0'}`} data-id="element-150" data-mp="y4m5cgf4mm9o">
        More of the precision you planned reaches the tooth.
      </p>

      <p className={`mt-4 font-body text-[14px] leading-relaxed text-white/55 transition-opacity duration-300 ease-out ${beat >= 2 ? 'opacity-100' : 'opacity-0'}`} data-id="element-151" data-mp="wtlicodqtncf">
        Closer to the force system you intended.
      </p>
    </section>;
}